import React, { useState } from 'react'
import { Paper, Box } from '@material-ui/core'
import { useStyles } from './styles.js'
import Body from './Body'
import Header from './Header'
import Loader from './../../Utils/Loader'
import { INPROGRESS } from '../constants'

const HeatLoanForm = (props) => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const [headerState, setHeaderState] = useState(INPROGRESS)
  return (
    <Box>
      <Loader loading={loading} />
      <Box className={classes.heatLoanFormView}>
        <Paper
          elevation={2}
          square={true}
          className={classes.heatLoanFormWidget}
        >
          <Header headerState={headerState}></Header>
          <Body
            headerState={headerState}
            setLoading={setLoading}
            setHeaderState={setHeaderState}
          ></Body>
        </Paper>
      </Box>
    </Box>
  )
}
export default HeatLoanForm
